__webpack_require__.p = "https://monocle.dev.magmutual.com/";